import script from "./PodcastsBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./PodcastsBlock.vue?vue&type=script&setup=true&lang=ts"

import "./PodcastsBlock.vue?vue&type=style&index=0&id=fb992b08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb992b08"]])

export default __exports__